import { render, staticRenderFns } from "./AmazonCatalog.vue?vue&type=template&id=1c9498b8"
import script from "./AmazonCatalog.vue?vue&type=script&lang=js"
export * from "./AmazonCatalog.vue?vue&type=script&lang=js"
import style0 from "./AmazonCatalog.vue?vue&type=style&index=0&id=1c9498b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports